export const FAMILY_MATCH_WRITE_APPLICATION_WITH_MATCHED_STUDENT =
  'FAMILY_MATCH_WRITE_APPLICATION_WITH_MATCHED_STUDENT';
export const FAMILY_MATCH_SET_FETCHING_APPLICATIONS =
  'FAMILY_MATCH_SET_FETCHING_APPLICATIONS';
export const FAMILY_MATCH_SET_FETCHING_STUDENTS =
  'FAMILY_MATCH_SET_FETCHING_STUDENTS';
export const FAMILY_MATCH_SET_ERROR = 'FAMILY_MATCH_SET_ERROR';
export const FAMILY_MATCH_SET_SYSTEMID_AND_HHID =
  'FAMILY_MATCH_SET_SYSTEMID_AND_HHID';
export const FAMILY_MATCH_ADD_STUDENT_ID_SEED =
  'FAMILY_MATCH_ADD_STUDENTIDSEED';
export const FAMILY_MATCH_REMOVE_STUDENT_ID_SEED =
  'FAMILY_MATCH_REMOVE_STUDENTIDSEED';
export const FAMILY_MATCH_SET_CONFIDENCE = 'FAMILY_MATCH_SET_CONFIDENCE';
export const FAMILY_MATCH_CHECK_STUDENT_GRID =
  'FAMILY_MATCH_CHECK_STUDENT_GRID';
export const FAMILY_MATCH_CHECK_APPLICATION_GRID =
  'FAMILY_MATCH_CHECK_APPLICATION_GRID';
export const FAMILY_MATCH_CHECK_SELECTED_CONFIDENCE =
  'CHECK_SELECTED_CONFIDENCE';
export const FAMILY_MATCH_SET_SUCCESS_FLAG = 'FAMILY_MATCH_SET_SUCCESS_FLAG';
export const FAMILY_MATCH_CLEAR_ERRORS = 'FAMILY_MATCH_CLEAR_ERRORS';
export const FAMILY_MATCH_SET_NO_STUDENT_FLAG =
  'FAMILY_MATCH_SET_NO_STUDENT_FLAG';
export const FAMILY_MATCH_GET_APPLICATIONS_AND_STUDENTS =
  'FAMILY_MATCH_GET_APPLICATIONS_AND_STUDENTS';
export const FAMILY_MATCH_CLEAR_SELECTED_STUDENTS =
  'FAMILY_MATCH_CLEAR_SELECTED_STUDENTS';
export const FAMILY_MATCH_TOGGLE_HISTORY = 'FAMILY_MATCH_TOGGLE_HISTORY';
export const FAMILY_MATCH_ADD_TO_HISTORY = 'FAMILY_MATCH_ADD_TO_HISTORY';



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/state/types.js